<template>
    <el-container>
       <ul >
          <li 
           v-for="(item,idx) in menuList"
           :key="idx"  
           :class="{'active':activeChoose==idx}" 
            @click="handle(idx)"
            >{{item}}</li> 
       </ul>
       
    </el-container>
</template>

<script>
export default {
    name:'leftMenu',
    props:{
        menuList:{
             default:null,
             type:Array
        },
        activeMenuIndex:{
            default:0,
            type:Number
        }
    },
    data() {
        return {
           activeChoose:0,
        };
    },
    components: {
    },
    watch:{
        activeMenuIndex(val){
            this.activeChoose = val;
            this.activeMenuIndex= val;
        }
    },
    computed:{
       
    },
    created(){
        if(this.activeMenuIndex){
            this.activeChoose=this.activeMenuIndex;
            this.$emit('activeMeun',this.menuList[this.activeMenuIndex]);
        }else{
            this.activeChoose=0;
            this.$emit('activeMeun',this.menuList[0]);
        }
    },
    methods:{
        handle(index){
            this.$router.push(this.$route.path)
            this.activeChoose = index;
            this.$emit('activeMeun',this.menuList[index])
        },
    }
}
</script>
<style lang="scss" scoped>
    body > .el-container {
        margin-bottom: 40px;
    }
    /deep/ .el-aside{
        overflow: hidden !important;
    }
    ul{
        list-style-type: none;
        margin:0px;
        padding:0px;
        text-align: left;
    }
    li{
        width: 251px;
        height: 70px;
        line-height: 70px;
        color: $font-color-gary1;
        font-size: $font-size-lv3;
        border: 1px solid $font-color-gary2;
            padding-left: 50px;
        border-bottom:0 ; 
        cursor: pointer;
        position: relative;
        &:last-child{
            border-bottom: 1px solid $font-color-gary2;
        }
        
    }
    .active {
        background:#ff4d4d;
        color: #fff;
        border: 1px solid #ff4d4d;
        &:before{
            display:block;
            content:'';
            border-width:10px;
            border-style:solid;
            border-color: transparent  transparent  transparent #ff4d4d;
            
            /* 定位 */
            position:absolute;
            right: -7%;
            top: 27px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/leftMenu.vue